import { createAsyncThunk } from "@reduxjs/toolkit";
import { FetchRequestHandler } from "../../utils/commonUtilities";
import { baseUrl } from "../../constants/Endpoints/EndPoints";

export const fetchSpecialityList = createAsyncThunk(
  "fetchSpeciality",
  async (providerId) => {
    const response = await FetchRequestHandler(
      "get",
      `${baseUrl}api/providers/${providerId}/specialties`
    );
    return response.data;
  }
);

export const fetchSpecialtyBoardOptions = createAsyncThunk(
  "fetchSpecialtyBoardOptions",
  async ({ query, type }) => {
    const response = await FetchRequestHandler(
      "get",
      `${baseUrl}api/specialty-board?query=${encodeURIComponent(query)}&type=${type}`
    );
    return response.data;
  }
);

export const fetchSpecialtyCertifications = createAsyncThunk(
  "fetchSpecialtyCertifications",
  async (type) => {
    const response = await FetchRequestHandler(
      "get",
      `${baseUrl}api/specialty-certification?type=${encodeURIComponent(type)}`
    );
    return response.data;
  }
);

export const fetchSpecialtyOptions = createAsyncThunk(
  "fetchSpecialtyOptions",
  async () => {
    const response = await FetchRequestHandler(
      "get",
      `${baseUrl}api/specialties`
    );
    return response.data;
  }
);

export const addProviderSpeciality = createAsyncThunk(
  "addProviderSpeciality",
  async ({ providerId, specialties }) => {
    const response = await FetchRequestHandler(
      "post",
      `${baseUrl}api/providers/${providerId}/specialties`,
      { specialties }
    );
    return response.data;
  }
);

export const updateProviderSpeciality = createAsyncThunk(
  "updateProviderSpeciality",
  async ({ providerId, specialtyId, specialtyData }) => {
    const payload = {
      specialties: [{
        specialtyName: specialtyData.specialtyName,
        displayId: specialtyData.displayId,
        year: specialtyData.year || 0,
        isValid: specialtyData.isValid || "true",
        isSelected: specialtyData.isSelected || true,
        institutionName: specialtyData.instituteName || ""
      }]
    };

    const response = await FetchRequestHandler(
      "put",
      `${baseUrl}api/providers/${providerId}/specialties/${specialtyId}`,
      payload
    );
    return response.data;
  }
);

export const fetchSpecialityLanguageSuggestions = createAsyncThunk(
  "fetchSpecialityLanguageSuggestions",
  async (query) => {
    if (!query || query.trim() === '') {
      return { success: true, data: { data: { institutionResponseDTO: { items: [] } } } };
    }
    
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/institutions?query=${encodeURIComponent(query)}&view=search`
    );

    return result;
  }
);
export const deleteProviderSpeciality = createAsyncThunk(
  "deleteProviderSpeciality",
  async ({ providerId, specialtyId, specialtyData }) => {
    const payload = {
      specialties: {
        specialtyName: specialtyData.specialtyName,
        displayId: specialtyData.displayId,
        year: specialtyData.year || 0, 
        isValid: false,
        inDeleteMode: true,
        institutionName: specialtyData.instituteName || ""
      }
    };

    const response = await FetchRequestHandler(
      "put",
      `${baseUrl}api/providers/${providerId}/specialties/${specialtyId}`,
      payload
    );
    return response.data;
  }
);

export const fetchSPBDCertificationList = createAsyncThunk(
  "fetchSPBDCertificationList",
  async (providerId) => {
    const response = await FetchRequestHandler(
      "get",
      `${baseUrl}api/providers/${providerId}/specialty-certifications`
    );
    return response.data;
  }
);

export const addProviderSPBDCertifications = createAsyncThunk(
  "addProviderSPBDCertifications",
  async ({ providerId, certifications }) => {
    const payload = {
      certifications: certifications
    };
    
    const response = await FetchRequestHandler(
      "put",
      `${baseUrl}api/providers/${providerId}/specialty-certifications`,
      payload
    );
    return response.data;
  }
);

export const deleteProviderSPBDCert = createAsyncThunk(
  "deleteProviderSPBDCert",
  async ({ providerId, specialtyCertDisplayId }) => {
    const response = await FetchRequestHandler(
      "put",
      `${baseUrl}api/providers/${providerId}/specialty-certifications/${specialtyCertDisplayId}`,
      []
    );
    return response.data;
  }
);

export const fetchDeleteSpeciality = createAsyncThunk(
  "fetchDeleteSpeciality",
  async ({ providerId, displayId, specialtyData }) => {
    const payload = {
      specialties: [{
        specialtyName: specialtyData?.specialtyName || "",
        displayId: displayId,
        year: specialtyData?.year || 0,
        isValid: "false",
        removedFromArray: true,
      }]
    };

    const result = await FetchRequestHandler(
      "put",
      `${baseUrl}api/providers/${providerId}/specialties/${displayId}`,
      payload
    );
    return result;
  }
);